/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Title,
} from '../models/index';
import {
    TitleFromJSON,
    TitleToJSON,
} from '../models/index';

/**
 * 
 */
export class TitleApi extends runtime.BaseAPI {

    /**
     * Get titles by ids
     */
    async getTitlesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Title>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/title`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TitleFromJSON));
    }

    /**
     * Get titles by ids
     */
    async getTitles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Title>> {
        const response = await this.getTitlesRaw(initOverrides);
        return await response.value();
    }

}
